"use strict";

var Dispatcher = require("./dispatcher");

function dispose() {
  Dispatcher.dispose();
  this.registry.dispose();
}

module.exports = dispose;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/dispose.js
 ** module id = 501
 ** module chunks = 0
 **/